import { Spinner as FluentSpinner, SpinnerSize as FluentSpinnerSize } from '@fluentui/react/lib/Spinner';
import React, { FC } from 'react';

import { NumericFontSize } from '../../util/styles/fluent9';
import { TextColor } from '../../util/styles/fonts';
import { useTheme } from '../../util/theme';
import ScreenreaderText from '../ScreenreaderText';
import Text from '../Text';

import { getClassNames, getFluentSpinnerStyles } from './Spinner.styles.legacy';
import { SpinnerColor, SpinnerProps, SpinnerSize } from './Spinner.types';

const labelColors: Record<SpinnerColor, TextColor> = {
  light: 'primary',
  metadata: 'metadata',
  light_blue: 'accent',
  dark: 'staticWhite',
};

const labelSizes: Record<SpinnerSize, NumericFontSize> = {
  large: 300,
  medium: 300,
  small: 300,
  xSmall: 200,
};

const fluentSpinnerSizes: Record<SpinnerSize, FluentSpinnerSize> = {
  large: FluentSpinnerSize.large,
  medium: FluentSpinnerSize.medium,
  small: FluentSpinnerSize.small,
  xSmall: FluentSpinnerSize.xSmall,
};

const Spinner: FC<SpinnerProps> = ({
  className,
  text,
  hideText,
  textPosition = 'beside',
  color = 'light',
  size = 'medium',
  isCentered = false,
}) => {
  const theme = useTheme();
  const textSize = labelSizes[size];
  const classNames = getClassNames(size, isCentered, textSize, textPosition, className);

  const label = hideText ? (
    <ScreenreaderText>{text}</ScreenreaderText>
  ) : (
    <Text className={classNames.label} color={labelColors[color]} size={textSize}>
      {text}
    </Text>
  );

  return (
    <div className={classNames.spinner}>
      <FluentSpinner size={fluentSpinnerSizes[size]} styles={getFluentSpinnerStyles(color, theme)} />
      {label}
    </div>
  );
};

/**
 * A `Spinner` is an outline of a circle which animates around itself indicating to the user that
 * things are processing. It is shown when we're unsure how long a task will take.
 */
export default Spinner;
